import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import ResponsiveDialog from "../common/ResponsiveDialog";
import AddPartyModal from "../addPartyModal/AddPartyModal";
import { Party } from "./Party";

interface ModalProps {
  open: boolean;
  handleClose: Function;
  selectParty?: Function;
  selectedParty?: any;
}

export default function SelectParty({
  open,
  handleClose,
  selectedParty,
  selectParty,
}: ModalProps) {
  const [createPartyOpen, setCreatePartyOpen] = useState(false);

  const handleKeyPress = (target: any) => {
    if (target.keyCode === 27) {
      handleClose(true);
    }
  };

  const handlePartyCreated = (createdParty: any) => {
    setCreatePartyOpen(false);
    if (selectParty) {
      selectParty(createdParty);
    }
    handleClose();
  };

  return (
    <>
      <ResponsiveDialog
        open={open}
        onClose={() => handleClose()}
        title="Select Party"
        subtitle="Search and select an account, or create a new one"
        maxWidth="md"
        headerAction={
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<Add />}
            onClick={() => setCreatePartyOpen(true)}
            sx={{
              minHeight: 36,
              px: { xs: 1.5, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.85rem" },
              whiteSpace: "nowrap",
            }}
          >
            Create New Party
          </Button>
        }
        contentSx={{ p: { xs: 1, sm: 2 } }}
      >
        <Box onKeyDownCapture={handleKeyPress} sx={{ width: "100%", height: "100%" }}>
          <Party
            modalShow={open}
            selectParty={(party: any) => {
              if (selectParty) {
                selectParty(party);
              }
              handleClose();
            }}
            selectedParty={selectedParty}
          />
        </Box>
      </ResponsiveDialog>

      {/* Nested modal for creating a new party and auto-picking it */}
      <ResponsiveDialog
        open={createPartyOpen}
        onClose={() => setCreatePartyOpen(false)}
        title="Create New Party"
        subtitle="Add a new customer or vendor account"
        maxWidth="sm"
      >
        <AddPartyModal
          isModal={true}
          onClose={() => setCreatePartyOpen(false)}
          onSuccess={handlePartyCreated}
        />
      </ResponsiveDialog>
    </>
  );
}
